<template>
    <div class="product-book-container__block">
        <div class="c-product-info-block">
            <a class="c-product-info-block__image" :href="item.url">
                <img class="c-product-info-block__cover" :src="item.thumbnail_path" alt="">
            </a>

            <div class="c-product-info-block__detail">
                <div class="c-product-info-block__title u-text-ellipsis has-2-lines">
                    <div class="u-text-ellipsis has-2-lines">
                        <a :href="item.url">{{ item.item_title }}</a>
                    </div>
                </div>
                <div v-if="item.talents" class="c-product-info-block__name">
                    <div class="u-text-ellipsis has-2-lines">
                        <a v-for="(talent, i) in item.talents" :key="`first-${i}`"
                        :href="route(route_list, 'site.talent.detail', {model_id: talent.id, model_name: talent.name})">
                        {{ talent.name }}
                        </a>
                    </div>
                </div>
                <div class="c-product-info-block__labels">
                    <div class="c-label is-new" v-if="item.is_new == true">New</div>
                    <div class="c-label is-photos">{{ item.category }}</div>
                    <div class="c-label is-up" v-if="item.is_pre_order == true">予約受付中</div>
                    <div class="c-label is-limited" v-if="item.with_extra == true">限定特典付</div>
                </div>
                <div class="c-product-info-block__price">
                    <!-- 定価 -->
                    <div class="c-price-and-tax is-subtle" :class="{'is-crossed': item.is_campaign || is_plus}">
                        <span class="c-price_value">￥{{ item.current_tax_base_price }}</span><span class="c-price_tax">（税込）</span>
                    </div>
                    <div class="c-product-info-block__discount">
                        <div v-if="item.is_campaign">
                            <!-- 割引 -->
                            <div class="c-product-info-block__discount-type is-pink u-mb-2">セール価格</div>
                            <div class="c-product-info-block__discount-price">
                                <div class="c-price-and-tax is-pink" :class="{'is-crossed': item.is_plus_discount}">
                                    <span class="c-price_value">￥{{ item.current_sale_price }}</span><span class="c-price_tax">（税込）</span>
                                </div>
                                <div class="c-label has-wide-padding is-pink">{{ item.discount_string }}OFF</div>
                            </div>
                        </div>
                        <div>
                            <div class="c-product-info-block__discount-type u-mb-2">プラス！会員価格</div>
                            <div class="c-product-info-block__discount-price">
                                <div class="c-price-and-tax is-orange">
                                    <span class="c-price_value">￥{{ item.is_plus_discount ? item.current_tax_price : item.current_tax_plus_price }}</span><span class="c-price_tax">（税込）</span>
                                </div>
                                <div v-if="parseInt(item.current_tax_price)" class="c-label has-wide-padding is-orange">{{ item.total_discount_string }}OFF</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="item.isReserveFlag" class="c-product-info-block__buttons">
                <span class="c-round-btn is-positive" style="background-color: gray;">予約済み</span>
            </div>
            <div v-else-if="item.hasSubscribe" class="c-product-info-block__buttons">
                <span class="c-round-btn is-positive" style="background-color: gray;">定期購読中</span>
            </div>
            <div v-else class="c-product-info-block__buttons">
                <a class="c-round-btn is-positive" :href="item.pre_order_url">予約をする</a>
            </div>
        </div>
    </div>
</template>

<script>
    import routeMixin from '../../../mixins/route.js';
    import moment from 'moment';

    export default {
        props: [
            'route_list',
            'item',
            'is_plus',
            'utm_content'
        ],
        mixins: [routeMixin],
        data() {
            return {
            }
        },
        computed: {
            moment: function (date) {
                return moment(date).format('YYYY/MM/DD');
            }
        },
        methods: {
            // 商品価格を3桁区切り
            formatPrice(price) {
                const formatter = new Intl.NumberFormat('ja-JP');
                return formatter.format(price);
            },
        },

    }
</script>

<style lang="scss" scoped>

.c-product-info-block {
    color: var(--gj-text-color);
    width: 100%;
    display: grid;
    grid-template-columns: 148px 1fr;
    grid-template-rows: 1fr min-content;
    gap: 16px 16px;
    grid-template-areas:
        "image detail"
        "buttons buttons";

    .c-product-info-block__image {
        position: relative;
        grid-area: image;
        display: flex;
        justify-content: flex-end;

        .c-product-info-block__cover {
            width: 95%;
            aspect-ratio: 148 / 209;
            object-fit: contain;
            border: 1px solid var(--gj-border-color);
        }
    }
    .c-product-info-block__detail {
        grid-area: detail;
        display: grid;
        grid-template-rows: repeat(4, min-content);
        grid-template-areas:
            "title"
            "name"
            "labels"
            "price";
        row-gap: 4px;
    }

    .c-product-info-block__buttons {
        grid-area: buttons;
        display: flex;
        gap: 8px;

        & > * {
            flex: 1;
            font-size: 10px;
            height: 29px;
        }
    }

    .c-product-info-block__title,
    .c-product-info-block__name {
        font-weight: 600;
        display: flex;
    }

    .c-product-info-block__title {
        grid-area: title;
        font-size: 20px;
        line-height: 135%;
        align-items: start;
        word-break: auto-phrase;
    }

    .c-product-info-block__name {
        grid-area: name;
        font-size: 14px;
        line-height: 130%;
        min-height: 36px;
        align-items: center;
    }
    .c-product-info-block__labels {
        grid-area: labels;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        min-height: 90px;
        gap: 2px;
        .c-label {
            margin: 0;
        }
    }

    .c-product-info-block__price {
        grid-area: price;
        display: flex;
        gap: 12px;
        flex-direction: column;
    }
    .c-product-info-block__discount {
        display: flex;
        gap: 12px;
        flex-direction: column;
    }

    .c-product-info-block__discount-type {
        font-size: 11px;
        font-weight: 600;
        line-height: 130%;

        &.is-pink {
            color: var(--gj-color-pink);
        }
    }
    .c-product-info-block__discount-price {
        display: flex;
        align-items: flex-start;
    }
}

@media (min-width: 768px) {
    .c-product-info-block {
        grid-template-columns: 117px 1fr 210px;
        grid-template-rows: 1fr;
        grid-template-areas: "image detail buttons";

        .c-product-info-block__discount {
            flex-direction: row;
        }

        .c-product-info-block__labels {
            min-height: 40px;
        }

        .c-product-info-block__buttons {
            flex-direction: column;
            justify-content: flex-end;
            & > * {
                flex: 0;
                font-size: 13px;
            }
        }
    }

    .is-tile .c-product-info-block {
        grid-template-columns: 1fr;
        grid-template-rows: repeat(3, min-content);
        row-gap: 7px;
        grid-template-areas:
            "image"
            "detail"
            "buttons";

        .c-product-info-block__detail {
            row-gap: 8px;
            grid-template-areas:
                "labels"
                "title"
                "name"
                "price";
        }

        .c-product-info-block__title {
            font-size: 13px;
            font-style: normal;
            font-weight: 300;
            line-height: 130%;
            color: var(--gj-text-color-light);
            min-height: 34px;
        }

        .c-product-info-block__image {
            .c-product-info-block__cover {
                aspect-ratio: 238 / 337;
            }
        }

        .c-product-info-block__discount {
            flex-direction: column;
            gap: 8px;
            min-height: 92px;
        }

        .c-product-info-block__buttons {
            margin-top: 9px;
        }
    }
}
</style>
